import React, { useRef } from "react";

export default function TermsAndConditionsModal({ open, onClose }) {
  const printRef = useRef();

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const win = window.open("", "", "height=700,width=900");
    win.document.write("<html><head><title>Terms & Conditions</title>");
    win.document.write(
      '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css">'
    );
    win.document.write("</head><body class='p-8 text-gray-800 bg-white'>");
    win.document.write(printContents);
    win.document.write("</body></html>");
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 500);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto relative">

        {/* Header */}
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center z-10">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Terms & Conditions
            </h1>
            <p className="text-sm text-gray-500">
              Child Care Legal Aid Clinic (CHICALAC)
            </p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={handlePrint}
              className="text-sm bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-md transition"
            >
              Export / Print
            </button>

            <button
              onClick={onClose}
              className="text-gray-400 hover:text-red-600 text-2xl font-bold transition"
              aria-label="Close"
            >
              &times;
            </button>
          </div>
        </div>

        {/* Content */}
        <div ref={printRef} className="p-6 space-y-6 text-gray-700 leading-relaxed">
          <p className="text-base">
            These Terms & Conditions govern your use of the Child Care Legal Aid
            Clinic (CHICALAC) website and legal services. By accessing or using
            this platform, you agree to comply with the terms outlined below.
          </p>

          <Section title="1. Legal Services">
            CHICALAC provides legal consultation and representation strictly
            within the framework of Kenyan law, with a focus on child protection,child rights,human rights
            and family justice.
          </Section>

          <Section title="2. Data Collection & Use">
            By using our website or services, you consent to the collection and
            processing of personal data in accordance with our Privacy Policy
            and the <strong>Data Protection Act, 2019</strong>.
          </Section>

          <Section title="3. No Guarantee of Outcome">
            Legal outcomes vary depending on individual circumstances. CHICALAC
            does not guarantee specific results for any legal matter.
          </Section>

          <Section title="4. Intellectual Property">
            All website content, including text and graphics, is the property of
            Child Care Legal Aid Clinic (CHICALAC). Unauthorized reproduction or
            distribution is prohibited.
          </Section>

          <Section title="5. Limitation of Liability">
            CHICALAC shall not be held liable for indirect, incidental, or
            consequential damages arising from the use of this website or our
            services.
          </Section>

          <Section title="6. Jurisdiction">
            These terms are governed by the laws of Kenya. Any disputes shall be
            resolved exclusively in Kenyan courts.
          </Section>

          <div className="pt-4 border-t text-sm text-gray-500">
            Effective date: <span className="font-medium">July 1, 2025</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const Section = ({ title, children }) => (
  <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
    <h2 className="text-lg font-semibold text-gray-900 mb-2">
      {title}
    </h2>
    <p className="text-gray-700">{children}</p>
  </div>
);
